import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavbarComponent from '../../components/Navbar/NavbarComponent';
import NavMenuComponent from '../../components/NavMenu/NavMenuComponent';
import LoadingComponent from '../../components/Loading/LoadingComponent';
import DashBoardComponent from '../../components/DashBoard/DashBoardComponent';
import styles from './index.module.css';
import { Row, Col, Table, Input, InputGroup, InputGroupText, Button } from 'reactstrap';
import { AiOutlineSearch, AiOutlineEye } from 'react-icons/ai';
import api from '../../service/api';
import Pagination from '../../utils/Paginations';

function Home() {
  const [respostas, setRespostas] = useState([]);
  const [respostasFiltradas, setRespostasFiltradas] = useState([]);
  const [busca, setBusca] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [vidas, setVidas] = useState([]);

  const [idadeFiltro, setIdadeFiltro] = useState('');
  const [setorFiltro, setSetorFiltro] = useState('');
  const [tendenciaFiltro, setTendenciaFiltro] = useState('');

  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const [totalResponses, setTotalResponses] = useState(0);

  const startItem = currentPage * pageSize + 1;
  const endItem = Math.min((currentPage + 1) * pageSize, totalResponses);

  const fetchGraficosGerais = async () => {
    try {
      const response = await api.get('/dashboard/tendencias-transtornos', {
        params: { startDate: '2000-01-01', endDate: '2100-12-31' },
      });
      const transtornos = [
        'Alimentação','Ansiedade','Bipolaridade','Burnout',
        'Dependência','Depressão','IRIS','SONO'
      ];
      const tendencias = transtornos.map((t) => {
        const item = response.data.find((d) => d.transtorno === t);
        return item ? parseFloat(item.media_score / 20).toFixed(2) : 0;
      });
      setVidas([{ nome: 'Tendências Gerais', tendencias }]);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    }
  };

  const fetchRespostas = async () => {
    try {
      const { data } = await api.get('/vida/ultimas-respostas');
      const invertida = [...data].reverse();
      setRespostas(invertida);
      setTotalResponses(invertida.length);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchRespostas();
    fetchGraficosGerais();
  }, []);

  useEffect(() => {
    let filtrados = respostas;

    if (busca) {
      const lb = busca.toLowerCase();
      filtrados = filtrados.filter((r) =>
        r.nome?.toLowerCase().includes(lb)
      );
    }
    if (idadeFiltro) {
      filtrados = filtrados.filter(
        (r) => r.idade?.toString() === idadeFiltro
      );
    }
    if (setorFiltro) {
      filtrados = filtrados.filter((r) =>
        r.setor?.toLowerCase().includes(setorFiltro.toLowerCase())
      );
    }
    if (tendenciaFiltro) {
      filtrados = filtrados.filter((r) =>
        r.tendencia?.toLowerCase().includes(tendenciaFiltro.toLowerCase())
      );
    }

    setRespostasFiltradas(filtrados);
    setTotalResponses(filtrados.length);
    setCurrentPage(0);
  }, [busca, idadeFiltro, setorFiltro, tendenciaFiltro, respostas]);

  if (isLoading) return <LoadingComponent />;
  if (error) return <div>Erro: {error}</div>;

  const dataToDisplay =
    busca || idadeFiltro || setorFiltro || tendenciaFiltro
      ? respostasFiltradas
      : respostas;

  const paginatedRespostas = dataToDisplay.slice(
    currentPage * pageSize,
    (currentPage + 1) * pageSize
  );

  return (
    <div className={styles.mainDiv}>
      <NavbarComponent />
      <NavMenuComponent />

      <div className={styles.route}>
        <Link to="/home" className={styles.link}>Home</Link> &gt; Dashboard
      </div>

      <div className={styles.headerRow}>
        <div className={styles.title}>Dashboard e Lista de Respostas</div>
        <div className={styles.overviewText}>
          Exibindo de {startItem} a {endItem} de {totalResponses}
        </div>
      </div>

      <Row className={styles.container}>
        <Col lg="7" md="12" className={styles.leftColumn}>
          <Row className={styles.filterRow}>
            <Col xs="12" md="4">
              <InputGroup className={styles.inputGroup}>
                <Input
                  size="sm"
                  placeholder="Idade"
                  className={styles.inputBusca}
                  value={idadeFiltro}
                  onChange={(e) => setIdadeFiltro(e.target.value)}
                />
                <InputGroupText className={styles.textBuscar}>
                  <AiOutlineSearch size={17} className={styles.iconBuscar}/>
                  Buscar
                </InputGroupText>
              </InputGroup>
            </Col>
            <Col xs="12" md="4">
              <InputGroup className={styles.inputGroup}>
                <Input
                  size="sm"
                  placeholder="Setor"
                  className={styles.inputBusca}
                  value={setorFiltro}
                  onChange={(e) => setSetorFiltro(e.target.value)}
                />
                <InputGroupText className={styles.textBuscar}>
                  <AiOutlineSearch size={17} className={styles.iconBuscar}/>
                  Buscar
                </InputGroupText>
              </InputGroup>
            </Col>
            <Col xs="12" md="4">
              <InputGroup className={styles.inputGroup}>
                <Input
                  size="sm"
                  placeholder="Tendência"
                  className={styles.inputBusca}
                  value={tendenciaFiltro}
                  onChange={(e) => setTendenciaFiltro(e.target.value)}
                />
                <InputGroupText className={styles.textBuscar}>
                  <AiOutlineSearch size={17} className={styles.iconBuscar}/>
                  Buscar
                </InputGroupText>
              </InputGroup>
            </Col>
          </Row>
          <div className={styles.chartColumn}>
            <DashBoardComponent vidas={vidas} />
          </div>
        </Col>

        <Col lg="5" md="12" className={styles.rightColumn}>
          <div className={styles.topControls}>
            <div className={styles.searchWrapper}>
              <InputGroup>
                <Input
                  size="sm"
                  placeholder="Nome"
                  className={styles.inputBuscaSmall}
                  value={busca}
                  onChange={(e) => setBusca(e.target.value)}
                />
                <InputGroupText className={styles.textBuscar}>
                  <AiOutlineSearch size={17} className={styles.iconBuscar}/>
                  Buscar
                </InputGroupText>
              </InputGroup>
            </div>
            <div className={styles.paginationControls}>
              <Pagination
                cPage={currentPage}
                pageSize={pageSize}
                countOrders={totalResponses}
                updateTablePage={setCurrentPage}
                showInfo={false}
              />
            </div>
          </div>

          <div className={styles.tableContainer}>
            <Table size="sm" striped className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.nomeCell}>Respondido por</th>
                  <th className={styles.nomeCell}>Enviado por</th>
                  <th>Questionário</th>
                  <th>Última Resposta</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {paginatedRespostas.map((r) => (
                  <tr key={r.id}>
                    <td className={styles.nomeCell} title={r.nome}>{r.nome}</td>
                    <td className={styles.nomeCell} title={r.parceiro_nome}>{r.parceiro_nome}</td>
                    <td>{r.questionario_nome}</td>
                    <td>{r.ultima_resposta}</td>
                    <td>
                      <Link to={`/vida/${r.id}`} state={{ nome: r.nome }}>
                        <Button size="sm" className={styles.buttonPerfil}>
                          <AiOutlineEye size={17} className={styles.buttonIcon}/>
                          Ver
                        </Button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Home;
